import $ from 'jquery'

export default class {

    constructor(options = {}) {
        this.conf = this.constructor.mergeSettings(options);
        if (this.conf.element) {
            this.init();
        }
        this.close.bind(this);
    }

    static mergeSettings(options) {
        const settings = {
            text: 'Bedankt!',
            amount: options.amount,
            element: null
        };

        const userSttings = options;
        for (const attrname in userSttings) {
            settings[attrname] = userSttings[attrname];
        }

        return settings;
    }

    init() {
        this.create();
    }

    create() {
        this.conf.element.style.display = "block";
        this.conf.element.innerHTML = "";

        let doc = document.documentElement;
        let left = (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
        let scrollTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

        let posTop = this.conf.element.getBoundingClientRect().top;
        if (posTop > 0 && posTop < window.innerHeight) {
            // in view
        } else {
            window.scrollTo(0, scrollTop + posTop - 150);
        }

        let frag = document.createRange().createContextualFragment(this.tempalte());
        frag.querySelector('.alert-cross').onclick = () => this.close();
        this.conf.element.appendChild(frag);
        if (this.conf.amount > 1) {
            setTimeout(() => {
                this.close();
            }, this.conf.amount)
        }
    }


    close() {
        this.conf.element.innerHTML = '';
        this.conf.element.style.display = "none";
    }

    tempalte() {
        return `
            <div class="alert">
                <div class="alert-cross">
                    <i class="fa fa-times"></i>
                </div>
                ${this.conf.text}
            </div>`
    }


}
